<era-temperature-ui [temperature]="currentTemperature()"></era-temperature-ui>